import { css } from '@emotion/react'
import { Primary500 } from '@mehilainen/mds-customer/colors'

// Lets remove this since there is no pattern anymore: https://porriainen.atlassian.net/browse/AV3-3455
const Pattern = css`
  background-color: ${Primary500};

  > h1 {
    color: white;
  }

  // Autocomplete from the design system does not play nice with pattern():
  // The following selector defaults to inheriting the background color if empty,
  // thus turning the same color as the pattern.
  .MuiAutocomplete-inputRoot {
    background-color: white !important;
  }
`

export default Pattern
